(function (global) {
  var PREFIX = 'randamu-cache:';
  var inflight = new Map();

  function storageKey(key) {
    if (typeof key !== 'string' || !key) return null;
    return key.indexOf(PREFIX) === 0 ? key : PREFIX + key;
  }

  function readStore(key) {
    try {
      var sk = storageKey(key);
      if (!sk || !global.localStorage) return null;
      var raw = global.localStorage.getItem(sk);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (
        !parsed ||
        typeof parsed.savedAt !== 'number' ||
        typeof parsed.ttlMs !== 'number' ||
        !('data' in parsed)
      ) {
        global.localStorage.removeItem(sk);
        return null;
      }
      if (Date.now() - parsed.savedAt >= parsed.ttlMs) {
        global.localStorage.removeItem(sk);
        return null;
      }
      return parsed.data;
    } catch (e) {
      try {
        var sk2 = storageKey(key);
        if (sk2 && global.localStorage) global.localStorage.removeItem(sk2);
      } catch (e2) {}
      return null;
    }
  }

  function writeStore(key, data, ttlMs) {
    try {
      var sk = storageKey(key);
      if (!sk || !global.localStorage) return;
      global.localStorage.setItem(
        sk,
        JSON.stringify({ savedAt: Date.now(), ttlMs: ttlMs, data: data })
      );
    } catch (e) {
      // Quota / private mode — fail open
    }
  }

  function removeStore(key) {
    try {
      var sk = storageKey(key);
      if (!sk || !global.localStorage) return;
      global.localStorage.removeItem(sk);
    } catch (e) {}
  }

  function getOrFetch(key, fetcher, options) {
    options = options || {};
    var ttlMs = typeof options.ttlMs === 'number' ? options.ttlMs : 2 * 60 * 60 * 1000;
    var shouldCache = typeof options.shouldCache === 'function' ? options.shouldCache : null;

    var cached = readStore(key);
    if (cached !== null) return Promise.resolve(cached);

    var sk = storageKey(key) || key;
    if (inflight.has(sk)) return inflight.get(sk);

    var promise = Promise.resolve()
      .then(function () {
        return fetcher();
      })
      .then(function (data) {
        var ok = shouldCache ? shouldCache(data) : true;
        if (ok) writeStore(key, data, ttlMs);
        return data;
      })
      .finally(function () {
        inflight.delete(sk);
      });

    inflight.set(sk, promise);
    return promise;
  }

  var api = {
    PREFIX: PREFIX,
    get: readStore,
    set: writeStore,
    remove: removeStore,
    getOrFetch: getOrFetch,
  };

  global.RandamuApiCache = api;
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
})(typeof window !== 'undefined' ? window : globalThis);
